import React, { useState } from "react";
import MaterialInput from "../../../components/MaterialInput";
import { Delete } from "@mui/icons-material";
import MaterialTypography from "../../../components/MaterialTypography";
import { Alert, Divider, Snackbar } from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialButton from "../../../components/MaterialButton";
import PercentIcon from "@mui/icons-material/Percent";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import MaterialBox from "../../../components/MaterialBox";

const TaxTableForm = ({
  taxEdit,
  taxView,
  tableData,
  confirmDelete,
  onDataChange,
}) => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
  });
  const showSnackbar = (message) => {
    setSnackbar({ open: true, message });
  };
  console.log("pageState--->", taxView, taxEdit);
  return (
    <MaterialBox>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity="error" // 👈 shows red background
          sx={{ width: "100%", fontSize: "0.8rem", textAlign: "center" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 1 }}>
          <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              textTransform="capitalize"
            >
              S. No
            </MaterialTypography>
          </MaterialBox>
        </Grid>
        <Grid size={{ xs: 12, md: 2 }}>
          <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              textTransform="capitalize"
            >
              From Amount (Rs)
            </MaterialTypography>
          </MaterialBox>
        </Grid>
        <Grid size={{ xs: 12, md: 2 }}>
          <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              textTransform="capitalize"
            >
              To Amount (Rs)
            </MaterialTypography>
          </MaterialBox>
        </Grid>

        <Grid size={{ xs: 12, md: 2 }}>
          <MaterialBox
            sx={{ textAlign: "left" }}
            mb={1}
            ml={0.5}
            lineHeight={0}
            display="inline-block"
          >
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Percentage of Deduction
            </MaterialTypography>
          </MaterialBox>
        </Grid>

        <Grid size={{ xs: 12, md: 2 }}>
          <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Taxable Amount
            </MaterialTypography>
          </MaterialBox>
        </Grid>

        <Grid size={{ xs: 12, md: 2 }}>
          <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Tax (Rs)
            </MaterialTypography>
          </MaterialBox>
        </Grid>

        <Grid size={{ xs: 12, md: 1 }}></Grid>
      </Grid>

      {tableData.map((item, index) => (
        <MaterialBox key={item.id}>
          <Grid container spacing={2} mb={1}>
            <Grid size={{ xs: 12, md: 1 }}>
              <MaterialInput disabled placeholder="S. No" value={index + 1} />
            </Grid>
            <Grid size={{ xs: 12, md: 2 }}>
              <MaterialInput
                name="fromAmount"
                placeholder="From Amount"
                value={item.fromAmount || ""}
                onChange={(e) => {
                  const inputValue = e.target.value.trim();
                  const isValid = /^\d*$/.test(inputValue); // only digits

                  if (inputValue === "" || isValid) {
                    onDataChange("fromAmount", inputValue, item.id);
                  }
                }}
                icon={{
                  direction: "right",
                  component: <CurrencyRupeeIcon size={18} color="black" />,
                }}
                disabled={true}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 2 }}>
              <MaterialInput
                name="toAmount"
                placeholder="To Amount"
                value={item.isLast ? "Above" : item.toAmount || ""}
                onChange={(e) => {
                  if (!item.isLast) {
                    const inputValue = e.target.value.trim();
                    const isValid = /^\d*$/.test(inputValue); // only digits

                    if (inputValue === "" || isValid) {
                      onDataChange("toAmount", inputValue, item.id);
                    }
                  }
                }}
                icon={{
                  direction: "right",
                  component: <CurrencyRupeeIcon size={18} color="black" />,
                }}
                disabled={item.isLast || taxView === true}
              />
            </Grid>

            <Grid size={{ xs: 12, md: 2 }}>
              <MaterialInput
                name="percentage"
                placeholder="Percentage"
                value={item.percentage || ""}
                onChange={(e) => {
                  const inputValue = e.target.value.trim();

                  const isValidFormat = /^\d*\.?\d*$/.test(inputValue);
                  const parsed = parseFloat(inputValue);

                  if (
                    inputValue === "" ||
                    (isValidFormat && !isNaN(parsed) && parsed <= 50)
                  ) {
                    onDataChange("percentage", inputValue, item.id);
                  } else if (!isValidFormat) {
                    showSnackbar("Only numbers and one decimal point allowed.");
                  } else if (parsed > 50) {
                    showSnackbar("Percentage should not be greater than 50%");
                  }
                }}
                icon={{
                  direction: "right",
                  component: <PercentIcon size={18} color="black" />,
                }}
                disabled={taxView === true}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 2 }}>
              <MaterialInput
                name="taxableAmount"
                placeholder="Taxable Amount"
                value={item.isLast ? "" : item.taxableAmount || ""}
                disabled //disable manual editing
                icon={{
                  direction: "right",
                  component: <CurrencyRupeeIcon size={18} color="black" />,
                }}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 2 }}>
              <MaterialInput
                name="tax"
                placeholder="Tax"
                value={item.isLast ? "" : item.tax || ""}
                disabled //disable manual editing
                icon={{
                  direction: "right",
                  component: <CurrencyRupeeIcon size={18} color="black" />,
                }}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 1 }}>
              {!item.isLast && (
                <MaterialButton
                  onClick={() => {
                    confirmDelete(item.id);
                  }}
                  variant="gradient"
                  color="error"
                  disabled={
                    taxView === true ||
                    tableData.filter((row) => !row.isLast).length === 1
                  }
                >
                  <Delete color="inherit" />
                </MaterialButton>
              )}
            </Grid>
          </Grid>
          <Divider
            style={{
              marginTop: 1,
            }}
          />
        </MaterialBox>
      ))}
    </MaterialBox>
  );
};

export default TaxTableForm;
